<!--忘记密码-->
<template>
  <div class="forgot-container" v-loading="loading" :element-loading-text="loadingText"
       element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.7)">
    <headerIndex/>
    <div class="content">
      <p class="span-default">重置密码
        <el-link type="primary" :underline="false" @click="goBack" class="el-active">返回账号登录</el-link>
      </p>
      <el-steps :active="isFinish" simple style="margin-top: 20px">
        <el-step title="安全验证">
          <i slot="icon" class="step-icon">1</i>
        </el-step>
        <el-step title="重置新密码">
          <i slot="icon" class="step-icon">2</i>
        </el-step>
        <el-step title="密码设置成功">
          <i slot="icon" class="step-icon">3</i>
        </el-step>
      </el-steps>
      <div class="console-container">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" v-show="isFinish==1">
          <el-form-item prop="account">
            <el-input v-model="ruleForm.account" maxlength="11" placeholder="请输入手机号" clearable>
              <i slot="prefix" class="iconfont icon-shouji"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input v-model="ruleForm.code" maxlength="6" placeholder="请输入验证码">
              <template slot="prefix">
                <i slot="prefix" class="iconfont icon-anquan"></i>
              </template>
              <template slot="suffix">
                <el-link style="color: #1637FF;font-size: 14px;" @click="getMobileCode" :underline="false"
                         v-if="timer==120">获取验证码
                </el-link>
                <el-link disabled v-else>{{ timer + 's后重试' }}</el-link>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="nextStep(1)">下一步</el-button>
          </el-form-item>
        </el-form>
        <el-form :model="passwordForm" status-icon :rules="passwordRules" ref="passwordForm" v-show="isFinish==2">
          <el-form-item prop="password">
            <el-input v-model="passwordForm.password" placeholder="请重置登录密码" clearable maxlength="16" type="password">
              <i slot="prefix" class="iconfont icon-lock"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="passwords">
            <el-input v-model="passwordForm.passwords" placeholder="请再次输入登录密码" maxlength="16" type="password">
              <i slot="prefix" class="iconfont icon-lock"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="nextStep(2)">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <footerIndex/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import footerIndex from '@/components/footer/index';
import {isMobile} from "@/common/tools"
import {verifyMoblie} from "@/api/loginApi";
import {sendsms, verifySms} from "@/api/currencyApi";
import {updatePws} from '@/api/systemSetting'

export default {
  name: "ForgotPassword",
  components: {headerIndex, footerIndex},
  data() {
    /*校验手机号*/
    let checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'));
      }
      if (isMobile(value)) {
        callback();
      } else {
        callback(new Error('请输入正确的手机号码'));
      }
    }
    /*校验密码 密码由8-16位数字、字母下划线等组成*/
    let checkPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'));
      }
      let regex = new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)(?![_/*+~!@#、|":$%^&*(){}_+=;}{,./?]+$)[0-9A-Za-z_/*+~!@#、|":$%^&*(){}_+=;}{,./?]{8,16}$');
      if (regex.test(value)) {
        callback();
      } else {
        callback(new Error('密码由8-16位数字、字母下划线等组成'));
      }
    }
    /*校验两次密码是否一致*/
    let checkPasswords = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'));
      }
      let regex = new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)(?![_/*+~!@#、|":$%^&*(){}_+=;}{,./?]+$)[0-9A-Za-z_/*+~!@#、|":$%^&*(){}_+=;}{,./?]{8,16}$');
      if (regex.test(value)) {
        if (value == this.passwordForm.password)
          callback();
        else
          callback(new Error('两次输入的密码不一致'));
      } else {
        callback(new Error('密码由8-16位数字、字母下划线等组成'));
      }
    }
    return {
      isFinish: 1,
      ruleForm: {
        account: '',
        code: '',
      },
      loadingText: '',
      loading: false,
      /*短信登录校验*/
      rules: {
        account: [
          {validator: checkMobile, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ]
      },
      timer: 120,
      isClickCode: false,
      passwordForm: {
        password: '',
        passwords: '',
      },
      passwordRules: {
        password: [
          {validator: checkPassword, trigger: 'blur'}
        ],
        passwords: [
          {validator: checkPasswords, trigger: 'blur'}
        ]
      },
      cid: 0,
    }
  },
  methods: {
    /*获取验证码*/
    getMobileCode() {
      if (this.timer < 120) {
        return
      }
      if (this.isClickCode) {
        return
      }
      /*校验手机号*/
      if (!isMobile(this.ruleForm.account)) {
        this.$message.error('请输入手机号')
        return
      }
      this.isClickCode = true;
      setTimeout(() => {
        this.isClickCode = false;
      }, 1000);
      this.loading = true;
      this.loadingText = '请稍后...';
      verifyMoblie({moblie: this.ruleForm.account}).then(res => {
        this.loading = false;
        if (res.code == '201') {
          this.cid = res.cid;
          sendsms({mobile: this.ruleForm.account, uuid: '', name: "重置密码"}).then(res => {
            if (res.code == 200) {
              this.$message.success('验证码已发送');
              let timer = setInterval(() => {
                if (this.timer <= 0) {
                  clearInterval(timer);
                  this.timer = 120;
                  return
                } else {
                  this.timer--
                }
              }, 1000)
            }
          })
        } else {
          this.$message.success('账号未注册！');
        }
      })
    },
    /*返回登录页*/
    goBack() {
      this.$router.replace({
        path: '/login'
      })
    },
    /*下一步*/
    nextStep(count) {
      /*手机验证*/
      if (count == 1) {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            /* 验证短信接口 */
            this.loading = true;
            this.loadingText = '验证中...';
            verifySms({smscode: this.ruleForm.code, uuid: this.ruleForm.account}).then(res => {
              if (res.code == 200) {
                this.loading = false;
                this.isFinish++
              }
            })
          } else
            return false
        });
      } else if (count == 2) { /*重置密码*/
        this.$refs.passwordForm.validate((valid) => {
          if (valid) {
            updatePws({id: this.cid, mobile: this.ruleForm.account, pwd: this.passwordForm.passwords}).then(res => {
              if (res.code == 200) {
                this.isFinish++
                this.$router.replace({
                  path: '/login',
                  query: {
                    mobile: this.ruleForm.account
                  }
                })
                this.$message.success('密码重置成功！');
              }
            })
          } else
            return false
        });
      } else
        this.isFinish++
    }
  },
  mounted() {
    this.ruleForm.account = this.$route.query.account;
  }
}
</script>
<style scoped>
.forgot-container >>> .content .step-icon {
  font-size: 12px;
  font-style: normal;
  color: #666666;
}

.forgot-container >>> .el-step__title.is-finish {
  color: #1637FF;
  font-size: 14px;
}

.forgot-container >>> .el-step__head.is-finish {
  color: #ffffff;
  border-color: #1637FF;
  background: #1637FF;
  border-radius: 50%;
}

.forgot-container >>> .el-step.is-simple .el-step__head {
  width: auto;
  font-size: 0;
  padding-right: 0px;
  margin-right: 10px;
}

.forgot-container >>> .el-input__inner {
  border-radius: 4px;
  border: 1px solid #FAFBFF;
  color: #333333;
  font-size: 14px;
  height: 55px;
  line-height: 55px;
  padding: 0 50px;
}

.forgot-container >>> input::-webkit-input-placeholder {
  color: #999999;
}

.forgot-container >>> .el-input__suffix {
  display: flex;
  align-items: center;
  right: 20px;
}

.forgot-container >>> .el-step.is-simple .el-step__arrow::after {
  background: #666666;
  width: 2px;
}

.forgot-container >>> .el-step.is-simple .el-step__arrow::before {
  background: #666666;
  width: 2px;
}

.forgot-container >>> .el-button--primary {
  color: #FFF;
  background-color: #1637FF;
  border-color: #1637FF;
  width: -webkit-fill-available;
  line-height: 25px;
}

.forgot-container >>> .el-input__prefix {
  left: 20px;
  color: #666666;
  font-size: 35px;
}

.forgot-container >>> .iconfont {
  font-size: 19px;
}

.forgot-container >>> .el-form-item__error {
  color: #FE273B;
  font-size: 12px;
  line-height: 1;
}

.forgot-container >>> .el-form-item {
  margin-bottom: 40px;
}

.forgot-container >>> .content .el-step__title.is-wait {
  color: #666666;
  font-size: 14px;
}

.forgot-container >>> .content .el-step.is-simple .el-step__icon {
  width: 21px;
  height: 20px;
  font-size: 14px;
}

.forgot-container >>> .content .el-step__icon.is-text {
  border-radius: 50%;
  border: 2px solid #666666;
}

.forgot-container >>> .is-finish .el-step__icon.is-text {
  border: 2px solid #1637FF;
}

.forgot-container >>> .el-step.is-simple .el-step__head .el-step__icon .is-text {
  border-color: #1637FF;
}

.forgot-container >>> .is-finish .step-icon {
  color: #ffffff;
}

.forgot-container >>> .content .el-step__title.is-process {
  font-weight: normal;
  color: #666666;
  font-size: 14px;
}

.forgot-container >>> .is-process .step-icon {
  color: #666666;
}
</style>
<style scoped lang="scss">
.forgot-container {
  background: center;

  .content {
    margin: 5% 18% 0 18%;

    .span-default {
      font-size: 22px;
      font-family: 'SourceHanSansCN';
      font-weight: 100;
      color: #333333;

      .el-active {
        color: #1637ff;
        font-size: 14px;
        float: right;
        vertical-align: text-bottom;
        font-family: 'SourceHanSansCN';
        height: 30px;
      }
    }

    .console-container {
      margin: 40px 30%;
    }
  }
}
</style>